import React, { Fragment, useEffect, useState } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TableSection from 'components/sales/tableSection/tableSection';
import useLatLng from 'hooks/uselatlng/uselatlng';
import { handleValidateObj } from 'constants/objValues/objvalues';
import { Button, FormGroup } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import Images from 'assets/images/imageData';
import GoogleMapReact from 'google-map-react';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import './attStyle.css';
import { Link } from "react-router-dom";

const AttendanceDetails = ({
  getAttendanceLocationType = null,
  getProfile,
  attendanceData = null,
  attendanceOfficeList = null,
  getAttendanceOfficeList = null,
  getAttendanceSiteList = null,
  attendanceSiteList = null,
  employeeAttendanceData = null,
  employeeCheckOutData,
  userProfile
}) => {
  const [attendaceList, setAttendancelist] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [locationType, setLocationType] = useState({ id: null, value: '' });
  const [locations, setLocations] = useState({ id: null, value: '' });
  const [remarkData, setRemarkData] = useState(null);
  const [purpose, setPurpose] = useState({ id: null, value: '' });
  const [isInOut, setIsInOut] = useState({ id: null, value: '' });
  const [mapLocation, setMapLocation] = useState({
    address: 'Delhi',
    lat: 0,
    lng: 0,
  });
  const [isFiled, setIsFiled] = useState(false);
  const [isAllow, setIsAllow] = useState(false);
  const [isAttendance, setIsAttendance] = useState(false);
  const [isLocationError, setIsLocationError] = useState(false);
  const islatlng = useLatLng();
  const headers = ['Name', 'Location Type', 'Detail', 'Type', 'Time'];

  const [modal, setModal] = useState(false);
  const [locationList, setLocationList] = useState(null);
  const [officeLocationList, setOfficeLocationList] = useState(null);

  useEffect(() => {
    if (getAttendanceLocationType) {
      getAttendanceLocationType();
    }
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
      
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if(!isNaN(lati) && !isNaN(langi)){
      setMapLocation({
        address: 'Delhi6',
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
    
   
  }, [islatlng]);

  useEffect(() => {
    if (attendanceData) {
      setAttendancelist(attendanceData);
    }
  }, [attendanceData]);

  useEffect(() => {
    setIsLoading(true);
    if (attendaceList?.location_type) {
      setIsLoading(false);
    }
  }, [attendaceList]);

  useEffect(() => {
    if (
      locationType?.id !== undefined &&
      locationType?.id !== null &&
      getAttendanceOfficeList !== null &&
      getAttendanceSiteList !== null &&
      islatlng !== null
    ) {
      setLocations({ id: null, value: '' });
      if (islatlng !== false) {
        setIsLocationError(false);
        if (locationType?.id === 1) {
          getAttendanceSiteList(
            locationType?.id,
            Number(islatlng?.lat) + 0.001,
            Number(islatlng?.lng) + 0.001
          );
        }
        if (locationType?.id === 2) {
          getAttendanceOfficeList(
            locationType?.id,
            Number(islatlng?.lat) + 0.001,
            Number(islatlng?.lng) + 0.001
          );
        }
        
      } else {
        setIsLocationError(true);
      }
    }
  }, [locationType, islatlng]);

  useEffect(() => {
    setLocationList([]);
    setOfficeLocationList([]);
    if (locationType?.id === 2) {
      console.log('office');
      // setLocationList(attendanceOfficeList);
      setOfficeLocationList(attendanceOfficeList);
    }
    if (locationType?.id === 1) {
      console.log('site');
      setLocationList(attendanceSiteList);
    }
    // if (attendanceSiteList !== null) {
    //   setLocationList(attendanceSiteList);
    // } else if (attendanceOfficeList !== null) {
    //   setLocationList(attendanceOfficeList);
    // }
  }, [attendanceOfficeList, attendanceSiteList]);

  useEffect(() => {
    if (
      attendaceList?.today_attendance &&
      attendaceList?.today_attendance !== undefined
    ) {
      const tablelist = attendaceList?.today_attendance;
      if (tablelist !== undefined && tablelist !== null) {
        const tableTimeupdate = tablelist.map((item) => ({
          ...item,
          time: item.time.split(' ')[1],
        }));
        if (tableTimeupdate) setTableData(tableTimeupdate);
        const inAttendance = tablelist.some(
          (el) => el.type.toLowerCase() === 'in'
        );
        const outAttendance = tablelist.some(
          (el) => el.type.toLowerCase() === 'out'
        );
        if (inAttendance && outAttendance) {
          setIsAttendance(true);
        } else {
          setIsAttendance(false);
        }
      }
    }
  }, [attendaceList]);

  const handleSubmitAttendanceData = async () => {
    // console.log(userProfile[0].id); return false;
    if (isAllow) {
      alert(localization.locationPermission);
    }
    var attdId = 0;
    try {
      if(typeof userProfile[0].id !== undefined){
        attdId = userProfile[0].id;
      }
    } catch (error) {
      // ...
    }
    
    if (employeeAttendanceData !== null && isAllow === false && attdId !== 0) {
      const data = {
        // id: locations?.id,
        att_id:attdId,
        lat: islatlng?.lat,
        lng: islatlng?.lng,
        type: 2,
        // locations: locations?.id,
        // purpose: purpose?.id,
        // locationType: locationType?.id,
      };
      // console.log(data); return false;
      const isNotEmpty = handleValidateObj(data);
      if (isNotEmpty !== false) {
        setIsFiled(false);
        const res = await employeeCheckOutData(data);
        if (res === true) {
          setModal(true);
          getAttendanceLocationType();
         await getProfile();
        }
      } else {
        setIsFiled(true);
      }
    }
  };


  function renderMarkers(map, maps) {
    let marker = new maps.Marker({
      position: {
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      },
      map,
      title: 'You are here!'
    });
  }
  return (
    <Layout
      className={isFiled ? 'requiredFileds' : ''}
      title={localization.checkOut}
      isLoading={isLoading}
    >
      <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.4.1/css/all.css" integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz" crossorigin="anonymous"/>
      <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet"></link>
      
      <div className="main-block">
        <div className="left-part">
          <i className="fas fa-car"></i>
          <i className="fas fa-at"></i>
          <i className="fas fa-mail-bulk"></i>
          
        </div>
      <form className="attForm">
        <h3>{localization.endjourney}</h3>
        <div className="info">
        <ConstantInput
                label={localization.remarks}
                type="text"
                value={remarkData}
                handleChange={(val) =>
                  setRemarkData(val)
                }
              />
          
        </div>

        <div className="map">
           {console.log(mapLocation)}
            <div className="google-map">
             {/* {(mapLocation &&
              <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyCweWEGenU5sDidT_1MKho5VoAhMC4CgtQ' }}
              defaultCenter={mapLocation}
              defaultZoom={15}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={({map, maps}) => renderMarkers(map, maps)}
            >
            </GoogleMapReact>
             )}             */}
              
            </div>
          </div>
          <br/>
          <Button
              onClick={handleSubmitAttendanceData}
              disabled={isLocationError}
            >
              {localization.submit}
            </Button>
      </form>
    </div>
     

      <ModalPop
        title={'Check Out'}
        show={modal}
        handleModalHide={() => {
          setModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>Succsessfully Ended Journey</h5>
          {/* <div className="row">
          <div className="col-5"></div>
          <div className="col-4"> */}
          <Link to="/dashboard/check_in" className="btn btn-primary mb-4">Go to {localization.startjourney}</Link>
          {/* </div>
          </div> */}
        </div>
      </ModalPop>
    </Layout>
  );
};

export default AttendanceDetails;
